export default "__VITE_ASSET__2ab37230__"